import { lazyLoad } from "utils/loadable"

export const TransmittalPage = lazyLoad(
  () => import("./index"),
  module => module.TransmittalPage,
)
